import moment from "moment";
import ToolTip from "../../../common/ToolTip/ToolTip";

const EncounterClaimInfo = (props) => {
  const { claimedCandidateInfo, jobTitle } = props;
  const shiftHoursCalc = (time) => {
    let shiftHours = "";
    const hours = Math.floor(parseInt(time) / 60);
    const minutes = parseInt(time) % 60;
    if (hours) {
      shiftHours += `${hours} ${parseInt(hours) === 1 ? "hr " : "hrs "}`;
    }
    if (minutes) {
      shiftHours += `${minutes} mins`;
    }
    return shiftHours;
  };

  return (
    <>
     <div className="col-lg-12 col-md-12">
          <div className="row">
            <div className="card-header">
              <b>
                <h5 class="mb-0">Encounter Shift Info</h5>
              </b>
            </div>
          </div>
        </div>
        <div className="card-body">
          {/* first-row => Shift Title */}
          <div className="row">
            <div className="d-flex">
              <div className="col-6">
                <label className="form-label">Shift Title:</label>
                <label>{jobTitle}</label>
              </div>
            </div>
          </div>
          {/* Second Row => Claimed details*/}
          <div className="row ">
            <div className="d-flex ">
              {/* Claimed By */}
              <div className="col-2">
                <label className="form-label">Claimed By:</label>
                <label>{claimedCandidateInfo?.candidateName}</label>
              </div>
              {/* Claimed Date */}
              <div className="col-2">
                <label className="form-label"> Claimed Date:</label>
                <label>
                  {claimedCandidateInfo?.claimedDateToDisplay
                    ? moment(claimedCandidateInfo?.claimedDateToDisplay).format(
                        "MM/DD/YYYY"
                      )
                    : ""}
                </label>
              </div>
              {/* Claimed Time */}
              <div className="col-2">
                <label className="form-label">Claimed Time:</label>
                <label>
                  {claimedCandidateInfo?.claimedDateToDisplay
                    ? moment(claimedCandidateInfo?.claimedDateToDisplay).format(
                        "hh:mm A"
                      )
                    : ""}
                </label>
              </div>
              <div className="col-2">
              </div>
              <div className="col-2"></div>
              <div className="col-2"></div>
            </div>
          </div>
          {/* Third Row => Shift Date details*/}
          <div className="row">
                  <div className="d-flex ">
                  <div className="col-2">
                  <label className="form-label">Completed Date:</label>
                    <label>
                    {props?.completedDateToDisplay
                        ? moment(props?.completedDateToDisplay).format(
                            "MM/DD/YYYY"
                          )
                        : ""}
                      {/* {props?.completedDateToDisplay} */}
                    </label>
                </div>
                  <div className="col-2">
                  <label className="form-label">Completed Time:</label>
                    <label>
                      {/* {props?.completedDateToDisplay} */}
                    {props?.completedDateToDisplay
                        ? moment(props?.completedDateToDisplay).format("hh:mm A")
                        : ""}</label>
                </div>
                <div className="col-2">
                  <label className="form-label">Paid Date:</label>
                    <label>
                      {claimedCandidateInfo?.paidDateToDisplay
                        ? moment(claimedCandidateInfo?.paidDateToDisplay).format(
                            "MM/DD/YYYY"
                          )
                        : ""}
                    </label>
                </div>
                <div className="col-2">
                  <label className="form-label">Paid Time:</label>
                    <label>
                      {claimedCandidateInfo?.paidDateToDisplay
                        ? moment(claimedCandidateInfo?.paidDateToDisplay).format("hh:mm A")
                        : ""}
                    </label>
                </div>
                <div className="col-2"></div>
                <div className="col-2"></div>
                <div className="col-2"></div>
                  </div>
              </div>
    
          {/* fourthRow => Incentive Details */}
          <div className="row">
            <div className="d-flex">
              <div className="col-2">
                <label className="form-label">Incentive:</label>
                <label>{props?.incentiveToDisplay}</label>
              </div>
              <div className="col-2">
                <label className="form-label">Incentive Mark Up:</label>
                <label>{props?.incentiveMarkup ? props?.incentiveMarkup :''}</label>
              </div>
              <div className="col-2">
                <label className="form-label">Incentive Billing Amount:</label>
                <label>
                  {props?.employerIncentiveToDisplay}
                </label>
              </div>
              <div className="col-2">
                <label className="form-label">Candidate Payment Amount:</label>
                <label>
                  {props?.candidateTotalShiftAmount ? `$ ${props?.candidateTotalShiftAmount}`:''}
                </label>
              </div>
              <div className="col-2">
                <label className="form-label">Employer Billing Amount:</label>
                <label>
                  {props?.employerTotalShiftAmount ? `$ ${props?.employerTotalShiftAmount}`:''}
                </label>
              </div>
           
            </div>
          </div>
        </div>
    </>
  );
};

export default EncounterClaimInfo;
